import Creator from "../../components/directories/creator";
import React, { Suspense, useState, useEffect } from "react"; 
import 'react-responsive-modal/styles.css';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import matchingService from "./MatchingService";

export default function Matching(subEntity: any) {
/*    

        var [listHeaders, listHeadersSet] = useState<any>([]);
     
        useEffect(() => {
            listHeadersSet(matchingService.getTemplateHeaders());
            console.log(matchingService.getTemplateHeaders());
        }, [listHeaders])
*/
        let myArrayMain = matchingService.myArrayMain;
        let myArrayMap = matchingService.myArrayMap;  
        let myArrayExternal = matchingService.myArrayExternal;


    return (
        <div className="box">
            <div className="box-header-main">
                <h2>Matching</h2>
            </div>
            <div className="box-content">

                <div className="ws-4">
                    <div className="ws-12 pm">
                        {myArrayMain?.map((item, index) => (
                            <ul className="ws-12 pm">
                                <li className="ws-6">
                                    <input className="pull-right mrl" type="text" value={item} />
                                </li>
                                <li className="ws-6 ptl">
                                    {myArrayMap[index]} 
                                </li>
                            </ul>
                        ))}
                    </div>
                </div>

                <div className="ws-4">
                    <div className="ws-12 pm">
                        {myArrayExternal?.map((item, index) => (
                            <ul className="ws-12 pm">
                                <li className="ws-6">
                                    <span className="pull-right mrl">
                                        {item}
                                    </span>
                                </li>
                            </ul>
                        ))}
                    </div>
                </div>

            </div>

        </div>
    );


}